import type { SystemResourcesTranslationMessages } from './systemResourcesTranslationMessages';

export const systemResourcesLanguageItalian: SystemResourcesTranslationMessages = {
  domains: {
    name: 'Domini',
    helperTexts: {
      assignDomainInput: 'Dominio a cui assegnare questo record',
      assignDomainArrayInput: 'Elenco di domini a cui assegnare questo record',
      organization: "Il nome dell'organizzazione",
      realm: 'Il dominio SIP',
      domainId: 'Id del dominio',
      license: 'Licenza del Dominio',
      altnames: {
        alias: 'Un alias di dominio/host',
      },
      metadata: {
        openai_api_key: 'Chiave necessaria per poter accedere alle API di OpenAI',
        ms_contact_sync: {
          sync_config: {
            rule_value_list: 'Separa piu valori con virgole',
          },
        },
      },
    },
    notifications: {
      invalidRealm: 'Formato dominio non valido',
      invalidMicrosoftSyncRule: 'Completa ogni regola oppure rimuovila',
    },
    fields: {
      fileUploadHint: 'Trascina un file .tar.gz qui, o clicca per sfogliare',
      id: 'ID',
      assigned_sip_profile: 'Profilo SIP',
      labels: { id: 'Etichette', name: 'Etichette' },
      altnames: 'Alias',
      enabled: 'Abilitato',
      enabled_features: 'Estensioni Abilitate',
      language: 'Lingua',
      license: 'Licenza',
      organization: 'Azienda',
      realm: 'Realm',
      metadata: {
        openai_api_key: 'Chiave API OpenAI',
        obfuscated_openai_api_key: 'Chiave API OpenAI (Offuscata)',
        ms_contact_sync: {
          enabled: 'Sincronizzazione Contatti Microsoft Abilitata',
          microsoft_config: {
            client_id: 'Client ID',
            client_secret: 'Client Secret',
            obfuscated_client_secret: 'Client Secret (Offuscato)',
            realm: 'Realm',
            tenant_id: 'Tenant ID',
          },
          sync_config: {
            active: 'Attivo',
            add_rule: 'Aggiungi regola',
            contacts_filter: 'Filtro Contatti',
            enum_active: {
              any: 'Qualsiasi',
              false: 'Inattivo',
              true: 'Attivo',
            },
            enum_operator: {
              eq: 'Uguale a',
              in: 'Nella lista',
            },
            enum_type: {
              all: 'Tutti',
              contacts: 'Contatti',
              users: 'Utenti',
            },
            ms_id_field: 'Campo ID MS',
            public_contacts_owner: 'Proprietario Contatti Pubblici',
            rule_field: 'Campo',
            rule_operator: 'Operatore',
            rule_value: 'Valore',
            type: 'Tipo di Sincronizzazione',
            users_filter: 'Filtro Utenti',
          },
        },
      },
    },
    operations: {
      edit: 'Modifica dominio',
      create: 'Crea dominio',
      delete: 'Elimina dominio',
      sections: {
        settings: 'Configurazione Dominio',
        metadata: 'Metadata',
        microsoftSync: 'Sincronizzazione Microsoft',
        license: 'Licenza',
        backup: 'Backup',
      },
    },
    license: {
      serial: 'Seriale',
      version: 'Versione',
      tenant: 'Tenant',
      issued_at: 'Data Emissione',
      expiry: 'Scadenza',
      resources: 'Risorse',
      users: 'Utenti',
      extensions: 'Interni',
      queues: 'Code',
      carriers: 'Trunk',
      ivrs: 'IVR',
      voicemails: 'Caselle Vocali',
      api_connectors: 'Connettori API',
      auth_providers: 'Provider Autenticazione',
      domains: 'Domini',
      features: 'Funzionalità Utenti',
      features_queues: 'Funzionalità Code',
      agents: 'Agenti',
      totp: 'TOTP',
      softphone_base: 'Softphone Base',
      softphone_premium: 'Softphone Premium',
      statistics: 'Statistiche',
      callback: 'Callback',
      expiry_resources: 'Scadenze Risorse',
      expiry_users: 'Scadenza Utenti',
      expiry_queues: 'Scadenza Code',
      metered_resources: 'Risorse Misurate',
      ai_calls_limit: 'Limite Chiamate AI',
      ai_calls_reset_period: 'Periodo Reset',
      error: 'Errore nel caricamento della licenza',
      noLicense: 'Nessuna licenza associata a questo dominio',
      yes: 'Si',
      no: 'No',
    },
    backup: {
      startBackup: 'Avvia Backup',
      success: 'Task di backup avviato',
      error: "Errore durante l'avvio del backup",
      button: 'Importa / Ripristina Backup',
      importTitle: 'Importa Backup Dominio',
      restoreTitle: 'Ripristina Backup Dominio',
      importMode: 'Importa',
      importModeDescription: "Crea un nuovo dominio dall'archivio di backup.",
      restoreMode: 'Ripristina',
      restoreModeDescription: "Sovrascrive un dominio esistente con l'archivio di backup.",
      realmOverride: 'Nuovo realm (opzionale)',
      targetDomain: 'Dominio di destinazione',
      importSuccess: 'Task di importazione backup avviato',
      restoreSuccess: 'Task di ripristino backup avviato',
      importError: "Errore nell'avvio dell'importazione backup",
      restoreError: "Errore nell'avvio del ripristino backup",
      apply: 'Applica',
    },
  },
  lcrs: {
    name: 'Least Cost Routing',
    fields: {
      id: 'ID',
      description: 'Descrizione',
      name: 'Nome',
      labels: { id: 'Etichette', name: 'Etichette' },
      rules: {
        id: 'ID',
        description: 'Descrizione',
        priority: 'Priorità',
        enabled: 'Abilitato',
        assigned_carriers: 'Trunk',
        dialingcode: 'Prefisso',
        matchrule: 'Regola di match',
      },
    },
    operations: {
      create: 'Crea LCR',
      edit: 'Modifica LCR',
      delete: 'Elimina LCR',
      sections: {
        details: 'Dettagli',
        rules: 'Regole',
      },
    },
    helperTexts: {
      rules: {
        assigned_carriers: 'Una collezione di sip trunk',
        description: 'Note casuali per la regola',
        dialingcode: 'Prefisso da abbinare e togliere dal numero chiamato',
        matchrule: "Un'espressione regolare da confrontare",
        priority: 'Priorità della regola, la più bassa vince',
      },
    },
  },
  carriers: {
    name: 'Trunk SIP',
    fields: {
      id: 'ID',
      enabled: 'Abilitato',
      description: 'Descrizione',
      name: 'Nome',
      mappings: 'Mapping',
      parameters: {
        password: 'Password SIP',
        username: 'Username SIP',
        realm: 'Realm',
        enable_reg: 'Abilita registrazione',
        expires: 'Durata registrazione',
        extension: 'Numero estensione',
        host: 'Host',
        transport: 'Trasporto',
        from_user: 'Utente (campo From)',
        from_domain: 'Dominio (campo From)',
        options_ping: 'Ping con SIP Options',
        callerid_in_from: 'Usa callerid nel From',
      },
      assigned_sip_profile: 'Profilo SIP',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    operations: {
      create: 'Crea trunk',
      edit: 'Modifica trunk',
      delete: 'Elimina trunk',
      sections: {
        details: 'Dettagli',
        parameters: 'Parametri',
      },
    },
    helperTexts: {
      mappings: 'Un insieme di mapping per questo trunk',
      parameters: {
        host: 'Endpoint remoto / Registrar',
        username: 'Nome utente di autenticazione, usato anche come utente from se from_user non è impostato',
        password: 'Password di autenticazione',
        realm: "Realm di autenticazione, lo stesso dell'host se non è impostato",
        extension: "Nome di registrazione sull'endpoint remoto, lo stesso del nome utente se non è impostato",
        from_user: 'Nome utente da usare in from, stesso nome utente, se non impostato',
        from_domain: "Dominio da usare in from, lo stesso del realm se impostato o dell'host",
        transport: 'Protocollo di trasporto',
        expires: 'Timer di scadenza della registrazione',
        enable_reg: "Abilita la registrazione remota all'endpoint",
        options_ping: "Abilita il monitoraggio dell'endpoint tramite ping SIP OPTIONS",
        callerid_in_from: 'Inserisci il numero del chiamente nel SIP From',
      },
    },
  },
  sip_profiles: {
    name: 'Profili SIP',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      '100rel': '100rel',
      inbound_codecs: 'Codec in Entrata',
      outbound_codecs: 'Codec in Uscita',
      session_timers: 'Timer di Sessione',
      ice: 'ICE',
      rtp_profile: 'Profilo RTP',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    operations: {
      create: 'Crea profilo',
      edit: 'Modifica profilo',
      delete: 'Elimina profilo',
      sections: {
        details: 'Dettagli',
        codecs: 'Codec',
      },
    },
    helperTexts: {
      '100rel': 'Abilita il supporto rfc3262',
      session_timers: 'Abilita il supporto dei timer della sessione SIP',
      ice: 'Abilita il supporto ad ICE. Necessario per i client WebRTC. Potrebbe non essere supportato da alcuni telefoni o trunk.',
      rtp_profile:
        'Profilo RTP da utilizzare. I profili RTP/SAVP(F) sono criptati. I client WSS/WebRTC utilizzano sempre UDP/TLS/RTP/SAVPF.',
    },
  },
  ap_settings: {
    name: 'Impostazioni',
  },
  ap_authentication: {
    name: 'Autenticazione',
  },
  ap_configurations: {
    name: 'Configurazioni',
    srtpValues: {
      disabled: 'Disabilitato',
      optional: 'Opzionale',
      compulsory: 'Obbligatorio',
    },
    helperTexts: {
      display_name:
        'Usa le doppie parentesi graffe per i placeholder. Variabili disponibili: {{lastname}}, {{firstname}}, {{extension}}.',
    },
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      settings: {
        admin_password: 'Password amministratore',
        ca_url: 'URL CA',
        call_waiting: 'Avviso di chiamata',
        codecs: 'Codec',
        display_method: 'Metodo di visualizzazione',
        display_name: 'Nome visualizzato',
        dscp_enable: 'Abilita DSCP',
        dscp_signal: 'Segnale DSCP',
        dscp_voice: 'Voce DSCP',
        fw_url: 'URL firmware',
        ldap_base_search: 'Base di ricerca LDAP',
        ldap_filter_name: 'Filtro LDAP nome',
        ldap_filter_number: 'Filtro LDAP numero',
        ldap_host: 'Host LDAP',
        ldap_port: 'Porta LDAP',
        ldap_title: 'Titolo LDAP',
        mcast_addr: 'Indirizzi multicast',
        mcast_label: 'Etichette multicast',
        mwi_voicemail_number: 'Numero voicemail MWI',
        mwi_voicemail_subscribe: 'Sottoscrizione voicemail MWI',
        ntp_server_1: 'Server NTP 1',
        ntp_server_2: 'Server NTP 2',
        outbound_backup_proxy_port: 'Porta SIP proxy outbound di backup',
        outbound_proxy_port: 'Porta SIP proxy outbound',
        reg_expiry: 'Scadenza registrazione',
        sip_port: 'Porta SIP',
        sip_transport: 'Trasporto SIP',
        srtp: 'SRTP',
        vlan_pcport_enable: 'Abilita VLAN porta PC',
        vlan_pcport_vid: 'ID VLAN porta PC',
        vlan_wanport_enable: 'Abilita VLAN porta WAN',
        vlan_wanport_vid: 'ID VLAN porta WAN',
      },
    },
    groups: {
      details: 'Dettagli',
      labels: 'Etichette',
      sip_parameters: 'Parametri SIP',
      voicemail_parameters: 'Parametri voicemail',
      ntp_parameters: 'Parametri NTP',
      generic_parameters: 'Parametri generici',
      vlan_parameters: 'Parametri VLAN',
      dscp: 'DSCP',
      multicast_addresses: 'Indirizzi multicast',
      dsp_parameters: 'Parametri DSP',
      firmware: 'Firmware',
      ldap_parameters: 'Parametri LDAP',
    },
    operations: {
      create: 'Crea configurazione',
      delete: 'Elimina configurazione',
      edit: 'Modifica configurazione',
      sections: {
        details: 'Dettagli',
        sip: 'SIP',
        device: 'Dispositivo',
        media: 'Media',
        directory: 'Rubrica',
        network: 'Rete',
      },
    },
  },
  ap_groups: {
    name: 'Gruppi',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      ap_configuration: "Configurazione d'autoprovisioning",
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    operations: {
      create: 'Crea gruppo',
      delete: 'Elimina gruppo',
      edit: 'Modifica gruppo',
      sections: {
        details: 'Dettagli',
      },
    },
  },
  ap_templates: {
    name: 'Template',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      markup: 'Markup',
      metadata: {
        mac_regex: 'Regex MAC',
        max_accounts: 'Max account',
        ua_patterns: 'Pattern User-Agent',
      },
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    operations: {
      create: 'Crea template',
      delete: 'Elimina template',
      edit: 'Modifica template',
      sections: {
        details: 'Dettagli',
        metadata: 'Metadati',
      },
    },
    defaultTemplate: {
      button: 'Carica template predefinito',
      dialogTitle: 'Carica template predefinito',
      selectLabel: 'Template',
      warning: 'Questa operazione sovrascriverà il contenuto attuale del campo markup.',
    },
    helperTexts: {
      ua_patterns: 'Espressione regolare confrontata con lo User-Agent del dispositivo durante il provisioning',
    },
    validation: {
      invalid_regex: "Deve essere un'espressione regolare valida",
    },
  },
  sip_devices: {
    name: 'Dispositivi SIP',
    fields: {
      id: 'ID',
      mac_address: 'Indirizzo MAC',
      description: 'Descrizione',
      ap_group: "Gruppo d'autoprovisioning",
      labels: { id: 'Etichette', name: 'Etichette' },
      sip_identities: 'Identita SIP',
      provisioning_last_successful_at: 'Ultimo provisioning riuscito',
      provisioning_user_agent: 'User agent di provisioning',
    },
    operations: {
      create: 'Crea dispositivo SIP',
      delete: 'Elimina dispositivo SIP',
      edit: 'Modifica dispositivo SIP',
      sections: {
        details: 'Dettagli',
      },
    },
  },
  inbound_e164s: {
    name: 'Inbound E164',
    fields: {
      id: 'ID',
      description: 'Descrizione',
      e164_match: 'E164 Matcher',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    operations: {
      create: 'Crea inbound E164',
      delete: 'Elimina inbound E164',
      edit: 'Modifica inbound E164',
      sections: {
        settings: 'Configurazione Inbound E164',
      },
    },
  },
};
